import apiClient from './apiClient';

export interface CreditApplication {
  id: number;
  submission_number?: string;
  debtor_id: number;
  debtor_name?: string;
  requested_amount: number;
  approved_amount?: number;
  loan_purpose?: string;
  loan_term?: number;
  interest_rate?: number;
  status: string;
  scoring_result?: number;
  analysis_notes?: string;
  approval_notes?: string;
  approved_by?: string;
  approved_date?: string;
  created_at: string;
  updated_at: string;
}

export interface CreditStats {
  totalApplications: number;
  drafts: number;
  inAnalysis: number;
  pendingApproval: number;
  approved: number;
  rejected: number;
  totalAmount: number;
}

const creditApi = {
  getAll: () => {
    return apiClient.get<CreditApplication[]>('/credit-applications');
  },

  getById: (id: number) => {
    return apiClient.get<CreditApplication>(`/credit-applications/${id}`);
  },

  create: (data: Partial<CreditApplication>) => {
    return apiClient.post<CreditApplication>('/credit-applications', data);
  },

  update: (id: number, data: Partial<CreditApplication>) => {
    return apiClient.put<CreditApplication>(`/credit-applications/${id}`, data);
  },

  delete: (id: number) => {
    return apiClient.delete(`/credit-applications/${id}`);
  },

  getStats: () => {
    return apiClient.get<CreditStats>('/credit-applications/stats/summary');
  },
};

export default creditApi;
